











































import { Component, Vue } from 'vue-property-decorator'
import { getModule } from 'vuex-module-decorators'
import SuporteUsuariosRemuneracaoStore from '@/components/RemuneracaoMedica/suporte/store/SuporteUsuariosRemuneracaoStore'
import { maskDate, maskHour } from '@/utils/common'

@Component
export default class ModalLogsSuporteUsuarios extends Vue {
  get getSuporteUsuariosRemuneracaoStore() {
    return getModule(SuporteUsuariosRemuneracaoStore, this.$store)
  }

  get showModal() {
    return this.getSuporteUsuariosRemuneracaoStore.showModalLogs
  }

  set showModal(value: boolean) {
    this.getSuporteUsuariosRemuneracaoStore.setShowModalLogs(value)
  }

  get logs() {
    return this.getSuporteUsuariosRemuneracaoStore.logs
  }

  dateMask(value: string) {
    return maskDate(value)
  }

  hourMask(value: string) {
    return maskHour(value)
  }

  close() {
    this.getSuporteUsuariosRemuneracaoStore.setShowModalLogs(false)
  }
}
